import { LocalOptions } from 'src/components/hook-form/types';
import { QuoteStage, QuoteStatus } from 'src/redux/types/quoteSlice';

export const quoteStatus = {
	chasing: 'CHASING',
	discussing: 'DISCUSSING',
	none: '-',
} as const;

export const quoteStage = {
	quoteNotSent: 'QUOTE_NOT_SENT',
	quoteSent: 'QUOTE_SENT',
	quoteOnboarding: 'QUOTE_ONBOARDING',
	quoteAccepted: 'QUOTE_ACCEPTED',
	quoteLost: 'QUOTE_LOST',
} as const;

export const labelByQuoteStatus: Record<QuoteStatus, string> = {
	CHASING: 'Chasing',
	DISCUSSING: 'Discussing',
	'-': '-',
};

export const labelByQuoteStage: Record<QuoteStage, string> = {
	QUOTE_ACCEPTED: 'Quote - Accepted',
	QUOTE_LOST: 'Quote - Lost',
	QUOTE_NOT_SENT: 'Quote - Not Sent',
	QUOTE_ONBOARDING: 'Quote - Onboarding',
	QUOTE_SENT: 'Quote - Sent',
};

export const quoteStageOptions = Object.values(quoteStage).reduce<LocalOptions[]>((acc, status) => {
	acc.push({ id: status, name: labelByQuoteStage[status] });

	return acc;
}, []);

export const quoteStatusOptions = Object.values(quoteStatus).reduce<LocalOptions[]>((acc, status) => {
	acc.push({ id: status, name: labelByQuoteStatus[status] });

	return acc;
}, []);
